import React, { useMemo } from 'react'
import SnapshotService from './Service'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'
import { ISnapshotProviderProps } from './Interface'

import SessionManagerService from 'smart-components/session-manager/Service'
import { useServiceState } from 'helpers'
import IUserData from 'types/sign-in/IUserData'
import { ILocation } from 'components/section-header/Interface'
import { IResponsesValue } from 'types/UserResponses'

const RESPONSE_KEYS = [
  'statNum',
  'statDetail',
  'funFact',
  'randomJob',
  'uniqueInterest',
  'tedTalk',
  'projectToLife',
  'avatar',
  'hometownLocation'
]

const Provider: React.FC<ISnapshotProviderProps> = ({ children, responses, user, publicMode }) => {
  const sessionState = useServiceState(SessionManagerService, false)
  const userResponsesManagerState = useServiceState(UserResponsesManagerService, false)

  const snapshotState = useMemo(() => {
    const currentResponses = responses || userResponsesManagerState.userResponses?.responses || ({} as IResponsesValue)
    const currentUser = user || sessionState.currentUser

    const responseBeans = SnapshotService.getResponseList(currentResponses)
    const jobDescription = SnapshotService.getJobDescription(currentResponses)
    const school = SnapshotService.getSchoolDescription(currentResponses)

    const questionsAnswers = RESPONSE_KEYS.reduce(
      (acc, key) => {
        return {
          ...acc,
          [key]: currentResponses[key]
        }
      },
      {
        user: null as IUserData,
        statNum: null as number,
        statDetail: null as any,
        funFact: null as string,
        randomJob: null as string,
        uniqueInterest: null as string,
        tedTalk: null as string,
        projectToLife: null as string,
        hometownLocation: null as ILocation,
        responseBeans: [] as string[],
        jobDescription: null as string,
        school: null as string,
        avatar: null as string
      }
    )

    return {
      ...questionsAnswers,
      user: currentUser,
      responseBeans,
      jobDescription,
      school
    }
  }, [user, responses, sessionState.currentUser, userResponsesManagerState.userResponses])

  return <React.Fragment>{children({ state: snapshotState, responses, publicMode })}</React.Fragment>
}

export default Provider
